import React from "react";
import UrlManagement from "./../../shared/url_management.js";

class Sort extends React.Component {
  constructor(props) {
    super(props);
    this.url = new UrlManagement();
    this.state = {
      sorting_options: [
        {
          display: "Description A-Z",
          field: "description_short",
          type: "asc"
        },
        {
          display: "Description Z-A",
          field: "description_short",
          type: "desc"
        },
        {
          display: "Stock Code A-Z",
          field: "stock_code",
          type: "asc"
        },
        {
          display: "Stock Code Z-A",
          field: "stock_code",
          type: "desc"
        },
        {
          display: "Part Code A-Z",
          field: "catalogue",
          type: "asc"
        },
        {
          display: "Part Code Z-A",
          field: "catalogue",
          type: "desc"
        }
      ]
    };
  }

  applySorting() {
    const field = this.refs.selectInput.value.split(",")[0];
    const type = this.refs.selectInput.value.split(",")[1];
    this.url.manageSortParams({ sortBy: field, sortType: type });
    this.props.handleSearch();
  }

  render() {
    return (
      <span className="products-summary__sort">
        <select
          className="products-summary__sort__select"
          onChange={() => this.applySorting()}
          ref="selectInput"
        >
          {this.state.sorting_options.map((s, i) => {
            return (
              <option key={i} value={`${s.field},${s.type}`}>
                {s.display}
              </option>
            );
          })}
        </select>
        <i className="material-icons products-summary__sort__arrow">
          keyboard_arrow_down
        </i>
      </span>
    );
  }
}

export { Sort as default };
